import React from 'react';

import { StyledTextLinkColor } from './styles';

const TextLinkColor = ({ color, hoverColor, to = '#', ariaLabel, children }) => {
  return (
    <StyledTextLinkColor color={color} hoverColor={hoverColor} to={to} aria-label={ariaLabel}>
      {children}
    </StyledTextLinkColor>
  );
};

export default TextLinkColor;
